<template>
<div class="main-welcome-info-block" 
:style="`backgroundImage: url('${mainWelcomeImg[pageIndex]}')`">
<button class="main-welcome-info-skip-button" @click="onSkipWelcomePgae">Пропустити</button>
<!-- <div class="main-welcome-info-text-container">
    <p class="main-welcome-info-text-container">{{ mainWelcomeText[pageIndex] }}</p>
</div> -->
<div ref="dots" class="main-welcome-info-page-dots-container">
    <div class="main-welcome-info-page-dots active"></div>
    <div class="main-welcome-info-page-dots"></div>
    <div class="main-welcome-info-page-dots"></div>
    <div class="main-welcome-info-page-dots"></div>
</div>
<button class="main-welcome-info-page-button" @click="onChangeInfoIndex()">{{ pageIndex === 3 ? 'Почати' : 'Далі' }}</button>
</div>
</template>

<script>

// import { HeartIcon, UserIcon, HomeIcon } from 'vue-feather-icons';

export default {
    name: "hello-page",
    components: {
   
    },
    props: {
        // priceDown: {
        //     type: Number,
        //     required: false
        // },
    },
    data() {
        return {
            mainWelcomeText: [
                'We provide high quality products just for you.',
                'Your satisfaction is our number one priority.',
                'Let’s fulfill your daily need with Zoop Store right now!'
            ],
            mainWelcomeImg: [
                require(`../assets/welcomeImg/Screen1.png`),
                require(`../assets/welcomeImg/Screen2.png`),
                require(`../assets/welcomeImg/Screen3.png`),
                require(`../assets/welcomeImg/Screen4.png`),
            ],
            pageIndex: 0
        }
    },
    mounted() {
   
    },
    methods: {
      onChangePage(page) {
        this.$emit('setIsChangePage', page)
      },
      onSkipWelcomePgae() {
        window.localStorage.setItem('welcome-page', 'true')
        this.$emit('onCloseWelcomePage')
      },
      onChangeInfoIndex() {
        if (this.pageIndex === 3) {
            window.localStorage.setItem('welcome-page', 'true')
            this.$emit('onCloseWelcomePage')
        } else {
            let activeDot = document.querySelector(".main-welcome-info-page-dots.active");
            if (activeDot) {
               activeDot.classList.remove("active");
            }
            this.pageIndex += 1
            this.$refs.dots.children[this.pageIndex].classList.add('active')
        }
      }
    },
    watch: {

    }
}
</script>

<style scoped>

.main-welcome-info-block {
    height: 100vh;
    width: 100vw;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}

/* .main-welcome-info-block::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(18, 18, 18, 0.00) -30%, rgba(18, 18, 18, 0.60) 61.67%, #121212 100%);
  z-index: 1;
} */

.main-welcome-info-skip-button {
    position: absolute;
    top: 30px;
    right: 17px;
    background: transparent;
    border: none;
    color: #FFF;
    font-family: "Comfortaa", sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    z-index: 2;
}

.main-welcome-info-page-button {
    position: absolute;
    bottom: 20px;
    width: 90%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 8px;
    padding: 12px;
    background: #1E7CE9;
    color: #FFF;
    text-align: center;
    font-family: "Comfortaa", sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    z-index: 2;
    border: none;
}

.main-welcome-info-text-container {
    position: absolute;
    bottom: 100px;
    width: 100%;
    z-index: 2;
}

.main-welcome-info-text-container {
    color: #FFF;
    text-align: center;
    font-family: 'Comfortaa', sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
}
.main-welcome-info-page-dots-container {
    position: absolute;
    bottom: 140px;
    z-index: 2;
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 5px;
}

.main-welcome-info-page-dots {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #6c6c6c;
    transition: all .5s ease;
}

.main-welcome-info-page-dots.active {
    width: 24px;
    height: 8px;
    border-radius: 5px;
    background: #fff;
}

</style>